import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { tableCustomStyles } from "../../utils/TableCustomStyles";

function DeadFreightVesselMaster() {
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage['userrole']  
  
  const getRolePermission = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/rolepermissions/');
        setTimeout(() => {
          if (response) {
              setData(response.data)
              setDataPending(false)
          }
        }, 500);
        
    } catch (err) {
        toast.error("Error in fetching user data! Try again.");
    }
  }

  const getCurrentUserRolePermission = async (roles) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
            
            const role_permissions_array = []
            for(let i=0; i<response.data.length; i++){
                for(let j=0; j<response?.data[i]?.permissions_array.length; j++){
                    if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                        role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                    }
                }
            }

            if(role_permissions_array){
                setCurrentUserRolePermissionData(role_permissions_array)
            }
              
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
      }

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false)
  }

  const handleDeleteModalOpen = () => {
    setShowDeleteModal(true)
  }


  useEffect(() => {
    getRolePermission()
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role)
  }, [user_role]);

  const columns = [
    {
      name: 'Module',
      selector: row => row.module,
      sortable: true,
    },
    {
      name: 'Sub Module',
      selector: row => row.submodule,
      sortable: true,
    },
    {
      name: 'Permission',
      selector: row => row.permission,
      sortable: true,
    },
    {
      name: 'Action',
      center: true,
      selector: row => <div>
        {
          currentUserRolePermissionData?.includes("master:deadfreightvessel:update")?
          <Button className="btn btn-sm btn-inox-green border-0" title="Update" data-bs-toggle="offcanvas" data-bs-target="#updateSection">
            <i className="fa fa-edit"></i>
          </Button>
          :
          ""
        }

        {
          currentUserRolePermissionData?.includes("master:deadfreightvessel:delete")?
          <Button className="btn btn-sm bg-danger border-0 mx-2" title="Delete" onClick={() => handleDeleteModalOpen()}>
            <i className="fa fa-trash"></i>
          </Button>
          :
          ""
        }
      </div>,
    }
  ];

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <TopNavbar sidebarCollapsed={menuDrawerShow} topNavbarStatic={true} sendDataToParent={handleDataFromTopNavBar}/>
      <SideNavbar sidebarCollapsed={menuDrawerShow} activeMenu="Master" activeSubMenu="DeadFreightVesselMaster" activeSubMenuLevel1="" permissionFromTopNavbar={dataFromTopNavBar}/>

      <div className={menuDrawerShow ? "row main-content-collapsed text-left py-0" : "row main-content text-left py-0"} >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button className="btn btn-sm btn-inox-green border-0 mx-2" onClick={() => setMenuDrawerShow(!menuDrawerShow)}>
                {menuDrawerShow?
                  <span><i className="fa fa-chevron-left mx-1"></i></span>:
                  <span><i className="fa fa-chevron-right mx-1"></i></span>
                }
              </Button>
              <span className="page-header-text">Dead Freight Vessel Master</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
            {
              currentUserRolePermissionData?.includes("master:deadfreightvessel:add")?
                <Button className="btn btn-sm btn-inox-green border-0  px-3 float-right" data-bs-toggle="offcanvas" data-bs-target="#addSection">
                  <i className="fa fa-plus fa-lg text-right" style={{ paddingRight: 10 }}></i>
                  <span className="fw-bold">Add Dead Freight Vessel</span>
                </Button>
              :
                ""
            }
            </div>
          </div>
        </div>

        <div className="col-12 text-left" style={{ marginTop: -5, paddingLeft: 20, paddingRight: 30, zIndex: 100 }}>
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={<Spinner className="mx-5 text-inox-green table-spinner" as="span" animation="border" size="lg" role="status" aria-hidden="true"/>}
            noDataComponent={<p className="text-center table-no-data">No Data Found</p>}
            pagination
            highlightOnHover
            fixedHeader
            customStyles={tableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal size="sm" show={showDeleteModal} onHide={handleDeleteModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>Close</Button>
          <Button variant="danger" onClick={handleDeleteModalClose}>Delete</Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div class="offcanvas offcanvas-bottom h-50" tabindex="-1" id="updateSection" aria-labelledby="offcanvasBottomLabel" data-bs-scroll="true">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Upload Record</h4>
            </div>
            <div className="col-6">
            <button type="button" class="btn btn-inox-green float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close">
                <i className="fa fa-times text-white"></i>
            </button>
            </div>
          </div>
        </div>
        <div class="offcanvas-body">
            Role Update
        </div>

        <div>
          <Button className="btn btn-inox-green border-0 canvas-button">
              <i className="fa fa-edit"></i> <span className="mx-2">Update</span>
          </Button>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div class="offcanvas offcanvas-bottom h-50" tabindex="-1" id="addSection" aria-labelledby="offcanvasBottomLabel" data-bs-scroll="true">
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">Add New Record</h4>
            </div>
            <div className="col-6">
            <button type="button" class="btn btn-inox-green float-right" data-bs-dismiss="offcanvas" aria-label="Close" title="Close">
                <i className="fa fa-times text-white"></i>
            </button>
            </div>
          </div>
        </div>
        <div class="offcanvas-body">
            Agent
        </div>

        <div>
          <Button className="btn btn-inox-green border-0 canvas-button">
              <i className="fa fa-plus"></i> <span className="mx-2">Add</span>
          </Button>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default DeadFreightVesselMaster;
